import { render, staticRenderFns } from "./CompanyAssetNote.vue?vue&type=template&id=a1610760&scoped=true"
import script from "./CompanyAssetNote.vue?vue&type=script&lang=js"
export * from "./CompanyAssetNote.vue?vue&type=script&lang=js"
import style0 from "./CompanyAssetNote.vue?vue&type=style&index=0&id=a1610760&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1610760",
  null
  
)

export default component.exports